export const modalConstants = {
    HIDE_MODAL: 'HIDE_MODAL',
    SHOW_MODAL: 'SHOW_MODAL',
    HIDE_CLOSEMODAL: 'HIDE_CLOSE_MODAL',
}
